import { Container, Grid, Link, List, ListItem, Box } from '@mui/material';
import React, { useState } from 'react';
import './Header.scss';
import { NavLink } from 'react-router-dom';

function Header() {

    const [activeNavBut, setActiveNavBut] = useState(false);

    const NavButFunc = () => {
        setActiveNavBut(activeNavBut => !activeNavBut);
    }

    const [activeSearch, setActiveSearch] = useState(false);

    const searchButFunc = () => {
        setActiveSearch(activeSearch => !activeSearch);
    }

    return (
        <header className='main_Header'>
            <Container maxWidth='lg' className='main_HeaderContainer'>
                <Grid container spacing={0} sx={{ alignItems: 'center' }}>
                    <Grid item xs={5} md={3}>
                        <Box className='logo_block'>
                            <Link href="/" className='main_logo'>BUSIN</Link>
                        </Box>
                    </Grid>
                    <Grid item xs={7} md={9}>
                        <Box className='header_right'>
                            <List className='main_nav'>
                                <ListItem>
                                    <NavLink to="/">Home</NavLink>
                                </ListItem>
                                <ListItem>
                                    <NavLink to="/Works">works</NavLink>
                                </ListItem>
                                <ListItem>
                                    <NavLink to="/About">about</NavLink>
                                </ListItem>
                                <ListItem>
                                    <NavLink to="/Blog">blog</NavLink>
                                </ListItem>
                                <ListItem>
                                    <NavLink to="/OurService">service</NavLink>
                                </ListItem>
                                <ListItem>
                                    <NavLink to="/Contact">contact</NavLink>
                                </ListItem>
                            </List>
                            <Box className='navRight'>
                                <svg onClick={searchButFunc} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z" /></svg>
                                <Box id='navBut' className={activeNavBut ? 'active_navBut' : ''} onClick={NavButFunc}>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                    <Box className={`${'searchInputBox'}  ${activeSearch ? 'searchInputBox_active' : ""}`}>
                        <input type='text' placeholder='Search' className='searchInput'></input>
                        <svg className='searchCloseBut' onClick={searchButFunc} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" /></svg>
                    </Box>
                </Grid>
            </Container>
            <List className={`${'main_nav_mobile'} ${activeNavBut ? 'main_nav_mobile_active' : ''}`}>
                <ListItem>
                    <NavLink to="/">Home</NavLink>
                </ListItem>
                <ListItem>
                    <NavLink to="/Works">works</NavLink>
                </ListItem>
                <ListItem>
                    <NavLink to="/About">about</NavLink>
                </ListItem>
                <ListItem>
                    <NavLink to="/Blog">blog</NavLink>
                </ListItem>
                <ListItem>
                    <NavLink to="/OurService">service</NavLink>
                </ListItem>
                <ListItem>
                    <NavLink to="/Contact">contact</NavLink>
                </ListItem>
            </List>
        </header >
    )
}

export default Header;